import { render, staticRenderFns } from "./BulkStudentsUpload.vue?vue&type=template&id=915eac0c&scoped=true&"
import script from "./BulkStudentsUpload.vue?vue&type=script&lang=js&"
export * from "./BulkStudentsUpload.vue?vue&type=script&lang=js&"
import style0 from "./BulkStudentsUpload.vue?vue&type=style&index=0&id=915eac0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915eac0c",
  null
  
)

export default component.exports